"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ParagraphTextLayout = require("./ParagraphTextLayout");
Object.keys(_ParagraphTextLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ParagraphTextLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ParagraphTextLayout[key];
    }
  });
});
